/* eslint-disable no-undef */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import API from "service/api";
import qualityApi from "service/qualityApi";
import { Button, Card, CardBody, FormGroup, Form, Col } from "reactstrap";
import newApi from "service/newApi";
import { SessionTool } from "utils/SessionTool";
import { CookieTool } from "utils/CookieTool";

function generateRandomState(length = 32) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

const Login = () => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code) {
      const storedState = CookieTool.get("azure_login_state");
      if (!state || !storedState || state !== storedState) {
        toast.error(
          "Falha na validação de segurança do login (CSRF). Tente novamente.",
        );
        CookieTool.remove("azure_login_state");
        params.delete("code");
        params.delete("state");
        history.replace({
          pathname: location.pathname,
          search: params.toString() ? `?${params.toString()}` : "",
        });
        return;
      }
      CookieTool.remove("azure_login_state");
      params.delete("code");
      params.delete("state");
      history.replace({
        pathname: location.pathname,
        search: params.toString() ? `?${params.toString()}` : "",
      });
      newApi
        .post("v1/users/auth/azure", { code, resource: "platform" })
        .then((response) => {
          const { access_token, refresh_token, permissions } = response.data;

          const result = SessionTool.parseToken(access_token);

          if (access_token && result) {
            const refreshExpiry = CookieTool.getTokenExpiry(refresh_token);

            CookieTool.set(
              "admin_username",
              result.username || "",
              refreshExpiry,
            );
            CookieTool.set("admin_name", result.name || "", refreshExpiry);

            if (result.clientId && result.clientName) {
              CookieTool.set("admin_client_id", result.clientId, refreshExpiry);
              CookieTool.set("admin_client", result.clientName, refreshExpiry);
            }

            CookieTool.setLarge("access_token", access_token, refreshExpiry);
            CookieTool.setLarge("refresh_token", refresh_token, refreshExpiry);
            CookieTool.setLarge("permissions", permissions, refreshExpiry);

            API.defaults.headers["x-authorization"] = `Bearer ${access_token}`;
            qualityApi.defaults.headers["x-authorization"] =
              `Bearer ${access_token}`;
            newApi.defaults.headers["x-authorization"] =
              `Bearer ${access_token}`;
            toast.success("Login realizado com sucesso!");
            history.push("/admin/index");
          } else {
            toast.error("Nao foi possível realizar seu login!");
          }
        })
        .catch((error) => {
          console.error("Erro ao realizar login com Azure AD:", error);
          toast.error("Erro ao realizar login com Azure AD.");
          const params = new URLSearchParams(location.search);
          params.delete("code");
          history.replace({
            pathname: location.pathname,
            search: params.toString() ? `?${params.toString()}` : "",
          });
        });
      return;
    }

    const accessToken = CookieTool.getLarge("access_token");
    if (accessToken) {
      API.defaults.headers["x-authorization"] = `Bearer ${accessToken}`;
      qualityApi.defaults.headers["x-authorization"] = `Bearer ${accessToken}`;
      newApi.defaults.headers["x-authorization"] = `Bearer ${accessToken}`;
      history.push("/admin");
    }
  }, [location.search]);

  const handleLogin = async (data) => {
    if (!data.username.trim() || !data.password.trim()) {
      toast.error("Preencha todos os campos corretamente!");
      return;
    }

    setLoading(true);
    await API.post("/users/auth", data)
      .then((response) => {
        const { access_token, refresh_token, permissions } = response.data;

        const result = SessionTool.parseToken(access_token);

        if (!result) {
          toast.error(
            "Erro ao realizar login, Não foi possível recuperar as informações do seu usuário, tente novamente mais tarde.",
          );
          return;
        }

        if (access_token) {
          const refreshExpiry = CookieTool.getTokenExpiry(refresh_token);

          CookieTool.set("admin_username", result.username, refreshExpiry);

          if (result.clientId && result.clientName) {
            CookieTool.set("admin_client_id", result.clientId, refreshExpiry);
            CookieTool.set("admin_client", result.clientName, refreshExpiry);
          }

          CookieTool.setLarge("access_token", access_token, refreshExpiry);
          CookieTool.setLarge("refresh_token", refresh_token, refreshExpiry);
          CookieTool.setLarge("permissions", permissions, refreshExpiry);

          API.defaults.headers["x-authorization"] = `Bearer ${access_token}`;
          qualityApi.defaults.headers["x-authorization"] =
            `Bearer ${access_token}`;
          newApi.defaults.headers["x-authorization"] = `Bearer ${access_token}`;
          toast.success("Login realizado com sucesso!");
          history.push("/admin/index");
          return;
        } else {
          toast.error("Nao foi possível realizar seu login!");
        }
      })
      .catch((e) => {
        toast.error("Erro ao realizar login, verifique seu usuário e senha.");
        if (e?.response?.data?.attempts && e?.response?.data?.attempts >= 5) {
          toast.error(
            "Você excedeu o número de tentativas, tente novamente em 5 minutos.",
          );
        }
        if (e?.response?.data?.attempts < 5) {
          toast.error(
            `Você possui ${5 - e?.response?.data?.attempts} tentativas restantes.`,
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Col lg="5" md="7">
      <div style={{ textAlign: "center", margin: "40px" }}>
        <img
          alt="logo"
          className="logo"
          src={require("assets/img/brand/logo_white.png")}
        />
      </div>
      <Card className="bg-secondary shadow border-0">
        <CardBody className="px-lg-5 py-lg-5">
          <div className="text-center text-muted mb-4">
            <h3>Insira seus dados de login</h3>
          </div>
          <Form role="form" onSubmit={handleSubmit(handleLogin)}>
            <FormGroup className="mb-3">
              <input
                style={{
                  display: "block",
                  width: "100%",
                  height: "calc(1.5em + 1.25rem + 2px)",
                  padding: "0.625rem 0.75rem",
                  fontSize: "0.875rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                  color: "#8898aa",
                  border: "1px solid #cad1d7",
                  borderRadius: "4px",
                }}
                placeholder="Usuário"
                type="text"
                autoComplete="off"
                required
                {...register("username")}
              />
            </FormGroup>
            <FormGroup>
              <input
                style={{
                  display: "block",
                  width: "100%",
                  height: "calc(1.5em + 1.25rem + 2px)",
                  padding: "0.625rem 0.75rem",
                  fontSize: "0.875rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                  color: "#8898aa",
                  border: "1px solid #cad1d7",
                  borderRadius: "4px",
                }}
                placeholder="Senha"
                type="password"
                required
                {...register("password")}
              />
            </FormGroup>
            <div className="text-center">
              <Button color="primary" type="submit" disabled={loading}>
                {loading ? "Entrando..." : "Entrar"}
              </Button>
              <div>
                <hr />
              </div>
              <Button
                color="default"
                type="button"
                onClick={() => {
                  const state = generateRandomState();
                  CookieTool.set("azure_login_state", state);

                  const authUrl =
                    `${process.env.REACT_APP_CTE_B2C_AUTHORITY}?` +
                    `client_id=${process.env.REACT_APP_CTE_B2C_CLIENT_ID}&` +
                    "response_type=code&" +
                    `redirect_uri=${encodeURIComponent(process.env.REACT_APP_CTE_B2C_REDIRECT_URI)}&` +
                    "response_mode=query&" +
                    `scope=${encodeURIComponent(process.env.REACT_APP_CTE_B2C_SCOPE)}&` +
                    `state=${state}&` +
                    "nonce=defaultNonce";

                  window.location.href = authUrl;
                }}
              >
                Login com Azure AD B2C
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Login;
